document.addEventListener('DOMContentLoaded', function() {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    console.log('isSafari:', isSafari)
    // --- Константы для замены эмодзи ---
    const EMOJI_REPLACEMENTS = {
      "{heart}": "🫶",
      "{love}": "😍",
      "{lips}": "🫦",
      "{redheart}": "🤍",
      "{poop}": "💩",
      "{skull}": "💀",
      "{clown}": "🤡",
      "{cat}": "😺",
      "{nails}": "💅",
      "{money}": "🤑",
      "{devil}": "😈",
      "{fire}": "🔥"
    };

    // --- Маппинг кодов на URL изображений ---
    const EMOJI_IMAGES = {
      "{heart}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/heart.png?v=1751363260",
      "{love}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/love.png?v=1751362921",
      "{lips}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/lips.png?v=1751363261",
      "{redheart}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/redheart.png?v=1751362920",
      "{poop}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/poop.png?v=1751362921",
      "{skull}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/skull.png?v=1751362920",
      "{cat}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/cat.png?v=1751362920",
      "{money}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/money.png?v=1751362920",
      "{devil}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/devil.png?v=1751362921",
      "{fire}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/fire.png?v=1751362920"
    };
  
    // --- Функция для конвертации эмодзи в коды ---
    function emojiToCode(text) {
      let result = text;
      Object.entries(EMOJI_REPLACEMENTS).forEach(([code, emoji]) => {
        result = result.replace(new RegExp(emoji, 'g'), code);
      });
      return result;
    }
  
    // --- Функция для конвертации кодов в эмодзи ---
    function codeToEmoji(text) {
      let result = text;
      Object.entries(EMOJI_REPLACEMENTS).forEach(([code, emoji]) => {
        result = result.replace(new RegExp(code.replace(/[{}]/g, '\\$&'), 'g'), emoji);
      });
      return result;
    }
  
    // --- Функция для очистки ввода от запрещенных символов ---
    function cleanInput(text) {
      // убираем запрещённые символы: {}, / и "
      return text.replace(/[{}\/"]/g, '');
    }

    // --- Функция для проверки разрешенных эмодзи ---
    function isAllowedEmoji(char) {
      return Object.values(EMOJI_REPLACEMENTS).includes(char);
    }
  
    // --- Функция для преобразования в uppercase латиницу ---
    const layoutMap = {
      'й': 'q', 'ц': 'w', 'у': 'e', 'к': 'r', 'е': 't', 'н': 'y', 'г': 'u', 'ш': 'i', 'щ': 'o', 'з': 'p',
      'х': '[', 'ъ': ']', 'ф': 'a', 'ы': 's', 'в': 'd', 'а': 'f', 'п': 'g', 'р': 'h', 'о': 'j', 'л': 'k',
      'д': 'l', 'ж': ';', 'э': "'", 'я': 'z', 'ч': 'x', 'с': 'c', 'м': 'v', 'и': 'b', 'т': 'n', 'ь': 'm',
      'б': ',', 'ю': '.', 'ё': '`',
    
      // верхний регистр
      'Й': 'Q', 'Ц': 'W', 'У': 'E', 'К': 'R', 'Е': 'T', 'Н': 'Y', 'Г': 'U', 'Ш': 'I', 'Щ': 'O', 'З': 'P',
      'Х': '{', 'Ъ': '}', 'Ф': 'A', 'Ы': 'S', 'В': 'D', 'А': 'F', 'П': 'G', 'Р': 'H', 'О': 'J', 'Л': 'K',
      'Д': 'L', 'Ж': ':', 'Э': '"', 'Я': 'Z', 'Ч': 'X', 'С': 'C', 'М': 'V', 'И': 'B', 'Т': 'N', 'Ь': 'M',
      'Б': '<', 'Ю': '>', 'Ё': '~'
    };
    
    function toUppercaseLatin(text) {
      let result = '';
      for (let char of text) {
        // если символ есть в мапе — заменяем
        if (layoutMap[char]) {
          result += layoutMap[char];
        } else {
          result += char;
        }
      }
    
      // теперь убираем всё, что не латиница, цифры, пробелы или спецсимволы
      result = result.replace(/[^a-zA-Z0-9 !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/g, '');
    
      // и приводим к верхнему регистру
      return result.toUpperCase();
    }
  
    // --- Обновление атрибута engraving в корзине ---
    let isUpdatingAttributes = false; // Флаг для предотвращения одновременных вызовов
    
    function updateEngravingAttributes() {
      // Предотвращаем одновременные вызовы
      if (isUpdatingAttributes) {
        console.log('[engraving] Обновление атрибутов уже выполняется, пропускаем');
        return;
      }
      
      const skuSpan = document.querySelector('#spanSKU');
      const sku = skuSpan ? skuSpan.innerText.trim() : 'UNKNOWN';
      const engravingValue = lastSavedValue;
      
      isUpdatingAttributes = true;
  
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          let engraving = {};
          if (cart.attributes && cart.attributes.engraving) {
            try {
              engraving = JSON.parse(cart.attributes.engraving);
            } catch (e) {
              console.error('[engraving] Ошибка парсинга engraving:', e, cart.attributes.engraving);
            }
          }
          
          // Очищаем неактуальные гравировки для товаров, которых больше нет в корзине
          const cartSkus = cart.items.map(item => item.sku).filter(sku => sku);
          Object.keys(engraving).forEach(existingSku => {
            if (!cartSkus.includes(existingSku)) {
              delete engraving[existingSku];
            }
          });
          
          // Если гравировка пустая - удаляем её из атрибутов
          if (!engravingValue || engravingValue.trim() === '') {
            console.log('[engraving] Удаляем гравировку для SKU:', sku);
            delete engraving[sku];
          } else {
            // Конвертируем эмодзи в коды перед сохранением в атрибуты
            const engravingForAttributes = emojiToCode(engravingValue);
            console.log('[engraving] Сохраняем гравировку для SKU:', sku, 'значение:', engravingForAttributes);
            engraving[sku] = engravingForAttributes;
          }
          
          const newAttributes = {
            ...cart.attributes,
            engraving: JSON.stringify(engraving)
          };
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: newAttributes })
          })
            .then(res => res.json())
            .catch(err => {
              console.error('[engraving] Ошибка при обновлении cart/update.js:', err);
            });
        })
        .catch(err => {
          console.error('[engraving] Ошибка при получении cart.js:', err);
        })
        .finally(() => {
          isUpdatingAttributes = false; // Сбрасываем флаг в любом случае
        });
    }
  
    // --- Проверка существующей гравировки в корзине ---
    function checkExistingEngraving() {
      const skuSpan = document.querySelector('#spanSKU');
      const sku = skuSpan ? skuSpan.innerText.trim() : 'UNKNOWN';
      
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          if (cart.attributes && cart.attributes.engraving) {
            try {
              const engraving = JSON.parse(cart.attributes.engraving);
              
              if (engraving[sku]) {
                const existingValue = engraving[sku];
                
                // Конвертируем коды обратно в эмодзи для отображения
                const displayValue = codeToEmoji(existingValue);
                
                // Обновляем состояние UI
                lastSavedValue = displayValue;
                if (engraveInput) engraveInput.value = displayValue;
                if (engravePreviewSelected) {
                  engravePreviewSelected.dataset.value = displayValue;
                  engravePreviewSelected.innerHTML = 'Your chosen engraving: <strong>' + displayValue + '</strong>';
                }
                
                // Обновляем превью
                updatePreview();
                
                // Меняем состояние кнопки на "Edit Engraving"
                if (engravingOption) {
                  const title = engravingOption.querySelector('.engrave-option-title');
                  if (title) title.innerHTML = 'Edit engraving <span class="engrave-price">+5€</span>';
                  engravingOption.classList.add('engrave-added');
                }
                
                // Показываем +5€ рядом с ценой
                updatePriceAddon(true);
              }
            } catch (e) {
              console.error('[engraving] Ошибка парсинга существующего engraving:', e);
            }
          }
        })
        .catch(err => {
          console.error('[engraving] Ошибка при проверке существующей гравировки:', err);
        });
    }
    
  (function () {
    // Флаг для отслеживания уже добавленных обработчиков
    let fetchIntercepted = false;
    let xhrIntercepted = false;

    if (typeof window.fetch !== 'undefined' && !fetchIntercepted) {
      const origFetch = window.fetch;
      window.fetch = function (...args) {
        const [url] = args;
        const isCartAdd = typeof url === 'string' && (url.includes('/cart/add.js') || url.includes('/cart/add'));

        return origFetch.apply(this, args).then(response => {
          if (isCartAdd && response.ok) {
            // Добавляем небольшую задержку для избежания конфликтов
            setTimeout(() => {
              try {
                updateEngravingAttributes();
              } catch (error) {
                console.error('[engraving] Ошибка в updateEngravingAttributes после fetch:', error);
              }
            }, 100);
          }
          return response;
        }).catch(error => {
          console.error('[engraving] Ошибка в перехваченном fetch:', error);
          throw error; // Пробрасываем ошибку дальше
        });
      };
      fetchIntercepted = true;
    }

    if (!xhrIntercepted) {
      const origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        const isCartAdd = typeof url === 'string' && (url.includes('/cart/add.js') || url.includes('/cart/add'));

        if (isCartAdd) {
          // Проверяем, не добавлен ли уже обработчик
          if (!this._engravingHandlerAdded) {
            this.addEventListener('load', function () {
              if (this.status >= 200 && this.status < 300) {
                setTimeout(() => {
                  try {
                    updateEngravingAttributes();
                  } catch (error) {
                    console.error('[engraving] Ошибка в updateEngravingAttributes после XHR:', error);
                  }
                }, 100);
              }
            });
            this._engravingHandlerAdded = true;
          }
        }

        return origOpen.apply(this, arguments);
      };
      xhrIntercepted = true;
    }

    // Убираем fallback обработчики, которые могут создавать конфликты
    // document.addEventListener('submit', function (e) {
    //   if (e.target.action && e.target.action.includes('/cart/add')) {
    //     setTimeout(updateEngravingAttributes, 300);
    //   }
    // });

    // document.addEventListener('click', function (e) {
    //   if (e.target.matches('[data-action="add-to-cart"], .add-to-cart, button[type="submit"]')) {
    //     setTimeout(updateEngravingAttributes, 300);
    //   }
    // });
  })();
  
    function debugEmojiInput() {
    const value = engraveInput.value;
    const inputValue = document.getElementById('debugInputValue');
    const unicodeCodes = document.getElementById('debugUnicodeCodes');
    const previewText = document.getElementById('debugPreviewText');
    const previewHTML = document.getElementById('debugPreviewHTML');
  
    // 1. Отобразим оригинальный текст
    inputValue.textContent = value;
  
    // 2. Разложим по символам и покажем юникоды
    const codes = [...value].map(char => {
      return `U+${char.codePointAt(0).toString(window.ShopifyEngravingData.maxSymbols).toUpperCase()}`;
    });
    unicodeCodes.textContent = codes.join(' ');
  
    // 3. Прочитаем textContent и innerHTML превью
    const preview = document.getElementById('engravePreview');
    previewText.textContent = preview.textContent;
    previewHTML.textContent = preview.innerHTML;
  }
  
    const options = document.querySelectorAll('.engrave-option');
    // Найти стандартную кнопку покупки Shopify
    // let buyBtn = document.querySelector('.product-form__submit, .shopify-payment-button__button, button[type=submit]');
    // --- визуальное отображение +5€ рядом с ценой ---
    function updatePriceAddon(show) {
      // Ищем контейнер цены более гибко
      const priceContainer = document.querySelector('.price-item, .price, .product__price, [data-price]');
      if (!priceContainer) {
        console.log('[engraving] Контейнер цены не найден');
        return;
      }
    
      let addonEl = priceContainer.querySelector('.engraving-addon-price');
      if (!addonEl) {
        addonEl = document.createElement('span');
        addonEl.className = 'engraving-addon-price';
        addonEl.style.marginLeft = '8px';
        addonEl.style.color = '#0071e3';
        addonEl.style.fontWeight = 600;
        addonEl.style.fontSize = 'inherit';
        priceContainer.appendChild(addonEl);
      }
    
      addonEl.textContent = show ? '+5€' : '';
      console.log('[engraving] Обновлен addon цены:', show ? '+5€' : 'скрыт');
    }
  
    // --- Гравировка ---
    const engravingOption = document.getElementById('engravingOption');
    const popupOverlay = document.getElementById('popupOverlay');
    const closePopupBtn = document.getElementById('closePopupBtn');
    const cancelPopupBtn = document.getElementById('cancelPopupBtn');
    const saveEngraveBtn = document.getElementById('saveEngraveBtn');
    const engraveInput = document.getElementById('engraveInput');
    const engravePreview = document.getElementById('engravePreview');
    const engravePreviewSelected = document.getElementById('engravePreviewSelected');
    const emojiList = document.getElementById('emojiList');
    let lastSavedValue = engravePreviewSelected ? (engravePreviewSelected.dataset.value || '') : '';
    let confirmPopup = null;
  
    // --- Открытие попапа по клику на всю engrave-option ---
    if (engravingOption) {
      engravingOption.addEventListener('click', function(e) {
        popupOverlay.style.display = 'flex';
        engraveInput.value = engravePreviewSelected.dataset.value || '';
        lastSavedValue = engraveInput.value;
        updatePreview();
      });
    }
  
    // --- Функция для отслеживания изменений SKU ---
    function setupSkuObserver() {
      const skuSpan = document.querySelector('#spanSKU');
      if (!skuSpan) return;
      
      // Создаем MutationObserver для отслеживания изменений в spanSKU
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            console.log('[engraving] SKU изменился, обновляем состояние гравировки');
            // Сбрасываем состояние гравировки при смене варианта
            lastSavedValue = '';
            if (engraveInput) engraveInput.value = '';
            if (engravePreviewSelected) {
              engravePreviewSelected.dataset.value = '';
              engravePreviewSelected.innerHTML = 'Add Engraving <span class="engrave-price">+5€</span>';
            }
            
            // Обновляем состояние кнопки
            if (engravingOption) {
              const title = engravingOption.querySelector('.engrave-option-title');
              if (title) title.innerHTML = 'Add Engraving <span class="engrave-price">+5€</span>';
              engravingOption.classList.remove('engrave-added');
            }
            
            // Скрываем +5€ рядом с ценой
            updatePriceAddon(false);
            
            // Обновляем превью
            updatePreview();
            
            // Проверяем существующую гравировку для нового SKU
            setTimeout(checkExistingEngraving, 100);
          }
        });
      });
      
      // Начинаем наблюдение за изменениями
      observer.observe(skuSpan, {
        childList: true,
        characterData: true,
        subtree: true
      });
      
      console.log('[engraving] Наблюдатель за SKU установлен');
    }
    
    // --- Проверяем существующую гравировку при загрузке страницы ---
    checkExistingEngraving();
    
    // --- Устанавливаем наблюдатель за изменениями SKU ---
    setupSkuObserver();
    
    // --- Наблюдатель за изменениями DOM для восстановления addon цены ---
    function setupPriceObserver() {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            // Проверяем, не исчез ли наш addon цены
            const priceContainer = document.querySelector('.price-item, .price, .product__price, [data-price]');
            if (priceContainer && !priceContainer.querySelector('.engraving-addon-price')) {
              // Если есть активная гравировка, восстанавливаем addon
              if (lastSavedValue && lastSavedValue.trim() !== '') {
                console.log('[engraving] Восстанавливаем addon цены после обновления DOM');
                updatePriceAddon(true);
              }
            }
          }
        });
      });
      
      // Наблюдаем за изменениями в body
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      console.log('[engraving] Наблюдатель за ценой установлен');
    }
    
    // --- Устанавливаем наблюдатель за изменениями цены ---
    setupPriceObserver();
  
    // --- Confirm popup ---
    function showConfirmPopup(onConfirm, onCancel) {
      if (confirmPopup) return;
      confirmPopup = document.createElement('div');
      confirmPopup.className = 'popup-overlay confirm-popup';
      confirmPopup.innerHTML = `
        <div class="popup">
          <button class="popup-close confirm-close" style="position:absolute;top:18px;right:18px;font-size:24px;background:none;border:none;cursor:pointer;">&times;</button>
          <div class="popup-header" style="font-size:20px;">Discard changes?</div>
          <div class="popup-desc" style="margin:10px 0 20px 0;">You have made changes to the engraving. Are you sure you want to leave without saving?</div>
          <div class="popup-actions">
            <button class="popup-cancel confirm-cancel">Continue Editing</button>
            <button class="popup-save confirm-leave" style="background:#e33c00;">Discard</button>
          </div>
        </div>
      `;
      document.body.appendChild(confirmPopup);
      
      // Добавляем обработчики событий
      confirmPopup.querySelector('.confirm-cancel').onclick = function() {
        document.body.removeChild(confirmPopup); 
        confirmPopup = null; 
        if (onCancel) onCancel();
      };
      confirmPopup.querySelector('.confirm-close').onclick = function() {
        document.body.removeChild(confirmPopup); 
        confirmPopup = null; 
        if (onCancel) onCancel();
      };
      confirmPopup.querySelector('.confirm-leave').onclick = function() {
        document.body.removeChild(confirmPopup); 
        confirmPopup = null; 
        if (onConfirm) onConfirm();
      };
    }
  
    function tryClosePopup() {
      if (engraveInput.value !== lastSavedValue) {
        showConfirmPopup(() => {
          engraveInput.value = lastSavedValue;
          updatePreview();
          popupOverlay.style.display = 'none';
        }, null);
      } else {
        popupOverlay.style.display = 'none';
      }
    }
  
    if (closePopupBtn) closePopupBtn.onclick = tryClosePopup;
    if (cancelPopupBtn) cancelPopupBtn.onclick = tryClosePopup;
    if (popupOverlay) {
      popupOverlay.addEventListener('click', function(e) {
        if (e.target === popupOverlay) tryClosePopup();
      });
    }
  
    // --- Сохранить гравировку ---
    if (saveEngraveBtn) {
      saveEngraveBtn.onclick = function() {
        const value = engraveInput.value.trim();
        if (value) {
          const title = engravingOption.querySelector('.engrave-option-title');
          if (title) title.innerHTML = 'Edit engraving <span class="engrave-price">+5€</span>';
          engravingOption.classList.add('engrave-added');
        } else {
          const title = engravingOption.querySelector('.engrave-option-title');
          if (title) title.innerHTML = 'Add Engraving <span class="engrave-price">+5€</span>';
          engravingOption.classList.remove('engrave-added');
        }
        updatePriceAddon(!!value);
        lastSavedValue = value;
        popupOverlay.style.display = 'none';
  
        // Обновляем превью выбранной гравировки
        if (engravePreviewSelected) {
          engravePreviewSelected.innerHTML = '<strong>Your chosen engraving: ' + value + '</strong>';
          engravePreviewSelected.dataset.value = value;
        }

        // Обновляем атрибуты корзины только если товар уже в корзине с гравировкой
        const skuSpan = document.querySelector('#spanSKU');
        const sku = skuSpan ? skuSpan.innerText.trim() : 'UNKNOWN';
        
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            // Проверяем, есть ли товар в корзине
            const cartItem = cart.items.find(item => item.sku === sku);
            if (cartItem) {
              // Если товар в корзине, обновляем атрибуты
              console.log('[engraving] Товар в корзине, обновляем гравировку:', value);
              updateEngravingAttributes();
            } else {
              // Если товар не в корзине, просто сохраняем локально для будущего добавления
              console.log('[engraving] Товар не в корзине, сохраняем локально:', value);
            }
          })
          .catch(err => {
            console.error('[engraving] Ошибка при проверке корзины:', err);
          });
      };
    }
  
  
  function isEmoji(char) {
    const emojiRegex = /\p{Extended_Pictographic}/u;
    return emojiRegex.test(char);
  }
  
  const monochromize = (emoji) => {
    const codepoints = Array.from(emoji).map(char => {
      const int = char.codePointAt(0);
      return int === 65039 ? 65038 : int;
    });
    return String.fromCodePoint(...codepoints);
  };
  
  const engravePreviewOutput = document.querySelector('.engrave-text')
    
  // function updatePreview() {
  //   const value = engraveInput.value;
  //   engravePreviewOutput.textContent = monochromize(value);
  // }
  
      function updatePreview() {
    const value = engraveInput.value;
    engravePreview.innerHTML = '';

    const span = document.createElement('span');
    span.className = 'engrave-preview-elements';

    for (let char of [...value]) {
      const innerSpan = document.createElement('span');

      if (char === ' ') {
        innerSpan.innerHTML = '&nbsp;';
        innerSpan.style.minWidth = '0.5em';
        innerSpan.style.display = 'inline-block';
      } else if (isEmoji(char)) {
        // Проверяем, разрешен ли эмодзи
        if (isAllowedEmoji(char)) {
          innerSpan.className = 'engrave-emoji';
          // Находим код для этого эмодзи
          const emojiCode = Object.keys(EMOJI_REPLACEMENTS).find(key => EMOJI_REPLACEMENTS[key] === char);
          if (emojiCode && EMOJI_IMAGES[emojiCode]) {
            const img = document.createElement('img');
            img.src = EMOJI_IMAGES[emojiCode];
            img.style.verticalAlign = 'middle';
            innerSpan.appendChild(img);
          } else {
            innerSpan.textContent = char;
          }
        } else {
          // Если эмодзи не разрешен, не отображаем его
          continue;
        }
      } else {
        innerSpan.className = 'engrave-text';
        innerSpan.textContent = char;
      }

      span.appendChild(innerSpan);
    }

    engravePreview.appendChild(span);
  }
  
  
  
    if (emojiList && engraveInput) {
      emojiList.addEventListener('click', function(e) {
        // Находим ближайшую кнопку эмодзи (клик может быть по img внутри кнопки)
        const emojiBtn = e.target.closest('.emoji-btn');
        if (emojiBtn) {
          const emojiCode = emojiBtn.dataset.code;
          const emoji = EMOJI_REPLACEMENTS[emojiCode];
          if (!emoji) return;
          
          const start = engraveInput.selectionStart;
          const end = engraveInput.selectionEnd;
          const value = engraveInput.value;
          if (value.length - (end - start) + emoji.length > window.ShopifyEngravingData.maxSymbols) return;
          engraveInput.value = value.slice(0, start) + emoji + value.slice(end);
          engraveInput.focus();
          engraveInput.selectionStart = engraveInput.selectionEnd = start + emoji.length;
          updatePreview();
        }
      });
      
      // для контроля и фильтрации ввода
      engraveInput.addEventListener('beforeinput', function(e) {
        if (e.inputType === 'insertText' || e.inputType === 'insertFromPaste') {
          const inputText = e.data;
          
          // Проверяем каждый символ
          let allowedText = '';
          for (let char of inputText) {
            if (isEmoji(char)) {
              // Если это эмодзи, проверяем разрешен ли он
              if (isAllowedEmoji(char)) {
                allowedText += char;
              }
              // Если не разрешен, просто пропускаем
            } else {
              // Для обычного текста применяем стандартную очистку
              const cleanedChar = cleanInput(toUppercaseLatin(char));
              if (cleanedChar) {
                allowedText += cleanedChar;
              }
            }
          }
      
          if (!allowedText) {
            e.preventDefault();
            return;
          }
      
          const start = engraveInput.selectionStart;
          const end = engraveInput.selectionEnd;
          const currentValue = engraveInput.value;
      
          const newValue = currentValue.slice(0, start) + allowedText + currentValue.slice(end);
      
          if (newValue.length <= window.ShopifyEngravingData.maxSymbols) {
            e.preventDefault();
            engraveInput.value = newValue;
            engraveInput.selectionStart = engraveInput.selectionEnd = start + allowedText.length;
            updatePreview();
          } else {
            e.preventDefault();
          }
        }
      });
      
      // отдельный listener для обновления превью при любом изменении (включая backspace/delete)
      engraveInput.addEventListener('input', function () {
        updatePreview();
      });
  
      
    }
  }); 
  
  // Убираем постоянную проверку корзины, которая может создавать конфликты
  // setInterval(() => {
  //   fetch('/cart.js')
  //     .then((res) => res.json())
  //     .then((cart) => {
  //       console.log('🛒 Cart:', cart);
  //     })
  //     .catch((err) => console.error('Ошибка при получении cart.js', err));
  // }, 5000);